<template lang="pug">
  span
    ul.m-0(v-if="isList")
      li(v-for="val in valueList") {{val}}
    span(v-else-if="typeof value === 'number'") {{ value % 1 === 0 ? value : value.toFixed(2) }}
    span(v-else-if="typeof value === 'string'") {{ value }}
    span(v-else-if="typeof value === 'boolean'")
      b-icon(v-if="value" type="is-success" icon="check")
      b-icon(v-else type="is-danger" icon="close")
    span(v-else-if="typeof value === 'object' && value !== null")
      b-icon(v-if="value.icon && !value.tooltip" :icon="value.icon.icon" :type="`is-${value.icon.type}`")
      span(v-if="value.value")
        statistic-data(:value="value.value")
      b-tooltip(v-if="value.tooltip" :label="value.tooltip" type="is-dark" position="is-top")
        span(v-if="value.label") {{value.label}}
        b-icon(v-if="value.icon" :icon="value.icon.icon" :type="`is-${value.icon.type}`")
</template>

<script>
export default {
  name: 'statistic-data',

  props: {
    value: {
      required: true,
    },
  },

  computed: {
    isList() {
      return Array.isArray(this.value);
    },
    valueList() {
      return this.isList ? this.value : [];
    },
  },
};
</script>
